import React from 'react';
import DataList from '../DataList';
import { getDomains, deleteDomain, bulkDeleteDomains } from '../../api/data';

const DomainsList: React.FC = () => {
  const config = {
    title: 'Domains',
    singularName: 'domain',
    columns: [
      { key: 'slug', label: 'Slug' },
      { key: 'name_en', label: 'English Name' },
      { key: 'name_ar', label: 'Arabic Name' },
      { key: 'document_count', label: 'Documents' },
      { key: 'is_active', label: 'Status', render: (val: boolean) => val ? 'Active' : 'Inactive' },
      {
        key: 'slug',
        label: 'Hosted page',
        render: (slug: string, item: any) => {
          if (item?.hosted_page_enabled === false) {
            return <span className="text-xs text-primary-400">Disabled</span>;
          }
          return (
            <a
              href={`/c/${encodeURIComponent(slug)}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              className="text-xs text-primary-700 hover:underline inline-flex items-center gap-1"
              title={`Open /c/${slug} in a new tab`}
            >
              Open
              <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
              </svg>
            </a>
          );
        },
      },
    ],
    fetchData: getDomains,
    deleteItem: deleteDomain,
    bulkDelete: bulkDeleteDomains,
    createRoute: '/data/domains/create',
    editRoute: (id: number) => `/data/domains/${id}/edit`,
  };

  return <DataList config={config} />;
};

export default DomainsList;
